// DO NOT ADD TO THIS FILE. It is deprecated. A centralized file of constants,
// detached from where they are used/needed, spreads implementation details
// needlessly throughout the codebase. If you need a constant, put it into the
// feature that uses it! If multiple features need a constant, export it from
// one! But also consider: wouldn't that constant be better as a function that
// you could mock? Perhaps two features don't need the constant, but instead
// need the result of a Request. Share a function that makes that request!

export const WEBGATE_DOMAIN = `https://generic.wg.spotify.com`;
export const WEBAPI_DOMAIN = 'https://api.spotify.com';

// client ids
export const CLIENT_ID_S4A_ONBOARDING = '6491562e26a74a4dae998b7dbaf6983f';

// webgate endpoints
export const MANAGEMENT_API = `${WEBGATE_DOMAIN}/s4a-service`;
export const S4X_DATA_API = `${WEBGATE_DOMAIN}/s4x-insights-api`;
export const IDENTITY_API = `${WEBGATE_DOMAIN}/artist-identity-view`;
export const CONCERTS_API = `${WEBGATE_DOMAIN}/sponcerts`;
export const ONBOARDING_API = `${WEBGATE_DOMAIN}/s4a-onboarding`;
export const TOKEN_API = `${WEBGATE_DOMAIN}/creator-auth-proxy`;
export const HOME_API = `${WEBGATE_DOMAIN}/s4x-home-service`;
export const MARKETPLACE_MGMT_API = `${WEBGATE_DOMAIN}/marketplace-mgmt`;
export const WALLET_API = `${WEBGATE_DOMAIN}/s4x-wallet`;
export const ACTIVITY_API = `${WEBGATE_DOMAIN}/activity-feed`;
export const SOUNDBETTER_SEARCH_API = `${WEBGATE_DOMAIN}/sbsearch`;

// webgate labs endpoints
export const LABS_API = `${WEBGATE_DOMAIN}/labs-service`;
export const XRAY_LAB_API = `${WEBGATE_DOMAIN}/creatorhack/xray`;
export const COLLAB_LAB_API = `${WEBGATE_DOMAIN}/artistinsights-neo4j-service`;
export const TRENDS_LAB_API = `${WEBGATE_DOMAIN}/best-trends`;

// external domains
export const IDENTITY_IMAGE_UPLOAD_API =
  'https://artist-identity-image.spotify.com';
export const CSV_DOWNLOAD_API = 'https://artistinsights-downloads.spotify.com';
export const MARQUEE_ADMIN_API = 'https://marqueeadmin.spotify.com';

// websocket endpoints
export const REALTIME_SOCKET_V3 =
  'wss://artistinsights-realtime3.spotify.com/ws';
